import apiSlice from 'renderer/shared/state/apiSlice';

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ─────────────────────────────────────────
    /* READ */
    getCart: builder.query({
      query: () => ({ url: '/cart', method: 'GET' }),
      providesTags: ['Cart'],
    }),

    // ─────────────────────────────────────────
    /* CREATE  ➜  POST /cart/item   (deduping handled server-side) */
    addToCart: builder.mutation({
      query: ({ productId, quantity, platform, hostApplication }) => ({
        url: '/cart/item', // <-- POST, no :id in the path
        method: 'POST',
        body: { productId, quantity, platform, hostApplication },
      }),
      invalidatesTags: ['Cart'],
    }),

    // ─────────────────────────────────────────
    /* UPDATE  ➜  PATCH /cart/item/:cartItemId */
    updateCartItem: builder.mutation({
      /*
        Pass the **cartItemId** you get back from GET /cart.
        Example:
          {
            cartItemId,        // required
            quantity,
            platform,
            hostApplication
          }
      */
      query: ({ cartItemId, quantity, platform, hostApplication }) => ({
        url: `/cart/item/${cartItemId}`,
        method: 'PATCH',
        body: { quantity, platform, hostApplication },
      }),
      invalidatesTags: ['Cart'],
    }),

    // ─────────────────────────────────────────
    /* DELETE  ➜  DELETE /cart/item/:cartItemId */
    removeCartItem: builder.mutation({
      query: ({ cartItemId }) => ({
        url: `/cart/item/${cartItemId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Cart'],
    }),

    // ─────────────────────────────────────────
    /* PROMO */
    validateDiscountCode: builder.mutation({
      query: (code) => ({
        url: '/cart/validate-discount',
        method: 'POST',
        body: { code },
      }),
    }),
  }),
});

export const {
  useGetCartQuery,
  useAddToCartMutation,
  useUpdateCartItemMutation,
  useRemoveCartItemMutation,
  useValidateDiscountCodeMutation,
} = extendedApi;
